var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9932 9.38862C19.1988 7.25251 16.5078 5.89482 13.4996 5.89482C10.4915 5.89482 7.80048 7.25251 6.00597 9.38862M26 6.4973C22.9292 3.06639 18.4668 0.907227 13.5 0.907227C8.53323 0.907227 4.07076 3.06639 1 6.4973M16.2949 15.6775C16.2949 17.2212 15.0437 20.9998 13.5 20.9998C11.9563 20.9998 10.7048 17.2212 10.7048 15.6775C10.7048 14.1338 11.9562 10.4998 13.4999 10.4998C15.0436 10.4998 16.2949 14.1338 16.2949 15.6775Z",
    stroke: "#95A4B4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5771 21.3887V24.194",
    stroke: "#95A4B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStations);
export default __webpack_public_path__ + "static/media/stations.57542ab070f82ec22069cac935725258.svg";
export { ForwardRef as ReactComponent };